import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** Queue title (Figma queue frame head). Each queue passes its own title key. */
export function ModerationPageHeader({
  titleKey,
  actions,
}: {
  titleKey: string;
  actions?: ReactNode | undefined;
}) {
  const { t } = useTranslation('moderation');

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <h1 className="text-[24px] font-semibold tracking-[-0.96px] text-foreground">
        {t(titleKey)}
      </h1>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
